<template>
    <div class="business-listing">
        <!-- Loading State (Initial) -->
        <div v-if="loading && !hasMoreData" class="text-center py-5">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading...</p>
        </div>

        <!-- Business Grid -->
        <div v-if="!loading || businesses.length > 0">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-6" v-for="business in businesses" :key="business.id">
                    <div class="card aos aos-init aos-animate" data-aos="fade-up">
                        <div class="blog-widget">
                            <div class="blog-img">
                                <a :href="'/business/' + business.location?.city_id + '/' + business.slug" class="">
                                    <img
                                        v-if="business.featured_banner && business.featured_banner.image"
                                        :src="business.featured_banner.image"
                                        class="img-fluid"
                                        :alt="business.featured_banner.title"
                                        @error="handleImageError"
                                    >
                                    <div v-else class="banner-placeholder">
                                        <div class="placeholder-content">
                                            <i class="fa-regular fa-image"></i>
                                            <span>{{ business.business_name || 'MYBN' }}</span>
                                        </div>
                                    </div>
                                </a>
                                <div class="fav-item">
                                    <span class="featured-text" v-if="business.is_featured">Featured</span>
                                    <!-- <a href="javascript:void(0)" class="fav-icon"><i class="fa-regular fa-heart"></i></a> -->
                                </div>
                            </div>
                            <div class="bloglist-content">
                                <div class="card-body">
                                    <div class="blogfeaturelink">
                                        <div class="grid-author">
                                            <img v-if="business.profilepic"
                                                :src="business.profilepic"
                                                :alt="business.business_name"
                                                @error="handleImageError">
                                        </div>
                                        <div class="blog-features">
                                            <a href="javascript:void(0)"><span><i class="fa-regular fa-circle-stop"></i> {{ business.managed_by }}</span></a>
                                        </div>
                                        <div class="blog-author text-end">
                                            <span><i class="fa fa-shopping-cart"></i>{{ business.stats.products_count }}</span>
                                        </div>
                                    </div>
                                    <h3>
                                        <a :href="'/business/' + business.location?.city_id + '/' + business.slug" class="">{{ business.business_name }}</a>
                                    </h3>
                                    <div class="blog-location-details">
                                        <div class="location-info">
                                            <i class="fa fa-map-marker"></i>
                                            {{ business.location?.city_name || business.city }}, {{ business.location?.state_name || business.state }}
                                        </div>

                                        <div class="views_count">
                                            <i class="fa-regular fa-eye"></i> {{ business.stats.total_views || business.id * Math.floor(Math.random() * 40) }}
                                        </div>

                                        <div class="location-info">
                                            <i class="fa-solid fa-calendar-days"></i>
                                            {{ $formatDate(business.updated_at, 'displayDate') }}
                                        </div>
                                    </div>
                                    <div class="business-description mt-2">
                                        <p class="text-muted">{{ truncate(business.description, 100) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from '../services/ApiService';

export default {
    name: 'FeaturedBusinessList',
    data() {
        return {
            businesses: [],
            loading: false,
            observer: null,
        };
    },
    mounted() {
        this.fetchBusinesses();
    },
    beforeUnmount() {
        // Cleanup
        if (this.observer) {
            this.observer.disconnect();
        }
    },

    methods: {
        async fetchBusinesses(reset = true) {
            if (reset) {
                this.loading = true;
            }
            try {
                const response = await ApiService.businesses.getFeatured();
                this.businesses = response.data.data || [];
            } catch (error) {
                console.error('Error fetching businesses:', error);
                if (reset) {
                    this.businesses = [];
                }
            } finally {
                this.loading = false;
                this.loadingMore = false;
            }
        },
        truncate(text, maxLength = 100) {
            if (!text || typeof text !== 'string') return '';

            // Strip HTML tags first
            const strippedText = text.replace(/<[^>]*>/g, '');

            // If empty after stripping tags
            if (strippedText.trim().length === 0) return '';

            // Check length after stripping HTML
            if (strippedText.length <= maxLength) return strippedText;

            const truncated = text.substr(0, maxLength);
            const lastSpace = truncated.lastIndexOf(' ');

            if (lastSpace > 0 && lastSpace > maxLength - 20) {
                return truncated.substr(0, lastSpace) + '...';
            }
            return truncated + '...';
        },
        handleImageError(event) {
            event.target.src = 'https://listee.dreamstechnologies.com/vue/assets/listgrid-1-C35U96GW.jpg';
        },
    }
};
</script>

<style scoped>
.business-listing {
    min-height: 400px;
    position: relative;
}

.card {
    transition: transform 0.2s;
    margin-bottom: 24px;
    height: 100%;
}

.card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.spinner-border {
    width: 3rem;
    height: 3rem;
}

.spinner-border-sm {
    width: 1.5rem;
    height: 1.5rem;
}

.empty-state {
    padding: 3rem;
    background: #f8f9fa;
    border-radius: 10px;
}

.end-of-results {
    padding: 1.5rem;
    background: #f8f9fa;
    border-radius: 8px;
    border: 2px dashed #dee2e6;
}

.end-of-results i {
    font-size: 2rem;
}

.scroll-sentinel {
    height: 1px;
    width: 100%;
    visibility: hidden;
    margin: 20px 0;
}

.blog-img img {
    width: 100%;
    height: 200px;
    object-fit: cover;
}
.business-description {
    font-size: 0.9rem;
    line-height: 1.5;
    color: #6c757d;
}


.banner-placeholder {
    width: 100%;
    height: 100%;
    min-height:200px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(135, 212, 251);
}

.placeholder-content {
    text-align: center;
    padding: 20px;
}

.placeholder-content i {
    font-size: 3rem;
    margin-bottom: 10px;
    opacity: 0.8;
}

.placeholder-text {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    opacity: 0.9;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .col-lg-4, .col-md-4, .col-sm-6 {
        margin-bottom: 20px;
    }

    .filters .row > div {
        margin-bottom: 15px;
    }
}

/* Loading animation */
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

.card {
    animation: fadeIn 0.5s ease-out;
}
</style>